// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1tPNx","buttons":"SendReceipts_buttons__3lj4U","email":"SendReceipts_email__2eL6X","bookApptTitle":"SendReceipts_bookApptTitle__ySPX6"};